import type { IconData } from '@stacksjs/iconify-core'

export const logoSocialMediaFacebookCircle: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M30.47 9.905h-1.52v-3.05h-1.53v-1.52H25.9v-1.53h-3.05v-1.52h-3.04V.765h-7.62v1.52H9.14v1.52H6.09v1.53H4.57v1.52H3.04v3.05H1.52v3.05H0v7.61h1.52v3.05h1.52v3.05h1.53v1.52h1.52v1.53h3.05v1.52h4.57v-10.67H9.14v-4.57h4.57v-6.09h1.52v-1.53h7.62v4.58h-4.57v3.04h6.1v1.53h-1.53v1.52h-1.52v1.52h-3.05v10.67h4.57v-1.52h3.05v-1.53h1.52v-1.52h1.53v-3.05h1.52v-3.05H32v-7.61h-1.53z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default logoSocialMediaFacebookCircle
